import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CssThemeService {
  private availableThemes: string[] = ['qwintal', 'natera'];

  getThemes(): string[] {
    return this.availableThemes;
  }

  isThemeAvailable(themeName: string): boolean {
    return this.availableThemes.includes(themeName);
  }
}